import { Box, Typography, Stack } from '@mui/material';
import React from 'react';

import {
  propertyLimitationValues,
  propertyOtherLimitationValues,
} from '@app/static/constants';
import { theme } from '@app/theme';
import { Product, ProductLegalOtherLimitationType } from '@app/types/catalog';

interface LegalLimitationInfoProps {
  product: Product;
}

export function LegalLimitationInfo({ product }: LegalLimitationInfoProps) {
  const rows = [
    {
      label: '法令上の制限',
      value: product.customFields.salesType && (
        <>
          <span>
            {(product.customFields.legalLimitations || [])
              .map((limitationCode) => propertyLimitationValues[limitationCode])
              .join('、')}
          </span>
          <br />
        </>
      ),
    },
    {
      label: 'その他の制限事項',
      value: (
        <>
          <Typography>
            {product.customFields.legalOtherLimitations &&
              product.customFields.legalOtherLimitations
                .map(
                  (limitationCode) =>
                    propertyOtherLimitationValues[limitationCode]
                )
                .join('、')}
          </Typography>
          <Typography>
            {
              Object.values(ProductLegalOtherLimitationType).find(
                (type) =>
                  type.key === product.customFields.legalOtherLimitationType
              )?.label
            }
          </Typography>
          <Typography>
            {product.customFields.legalOtherLimitationNote}
          </Typography>
        </>
      ),
    },
  ];
  return (
    <Box>
      <Typography
        width="100%"
        bgcolor={theme.palette.blueAccent.main}
        color="white"
        px={2}
        height={36}
        fontWeight={600}
        borderRadius={15}
        display="flex"
        alignItems="center"
        variant="h6"
      >
        制限事項
      </Typography>

      <Stack spacing={2.5} maxWidth={1040} mx="auto" mt={6} pb={7} width="100%">
        {rows.map(({ label, value }, index) => (
          <Stack
            borderBottom={1}
            borderColor="#E0E0E0"
            key={index}
            direction={{ sm: 'row', xs: 'column' }}
            spacing={1}
            pb={2.5}
          >
            <Typography
              sx={{
                color: '#718CA0',
                fontWeight: 700,
                minWidth: 200,
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </Typography>
            <Box
              sx={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {value}
            </Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
